import Data from "./Data.js";
import Renders from "./Renders.js";
import {gridLoading} from "./Utils.js";

export default class ActionBars {
    constructor() {
        this.actionBar = document.querySelector('.action__bar');
        this.initState = {};

        if (this.actionBar && this.actionBar.dataset.callback) {
            this.snapshotOfInitializeState();
            
            this.actionBar.querySelector('.action__item--clear-filters button').addEventListener('click', e => {
                this.restoreInitializeState();
            });

            this.actionBar.querySelector('.action__item--search button').addEventListener('click', e => {
                const searchInput = this.actionBar.querySelector('.action__item--search input');

                if (searchInput.value.trim().length) {
                    searchInput.value = '';
                    this.actionBar.querySelector('input:not([name="search"]):not([name="current-period"])').dispatchEvent(new Event('input', {bubbles: true}));
                }
            });

            if (this.actionBar.querySelector('.segments')) {
                this.segments();
            }

            this.actionBar.querySelector('.action__item--date-range button')?.addEventListener('click', () => {
                const inputs = this.actionBar.querySelectorAll('.action__item--date-range input');
                let hasValue = false;

                inputs.forEach(input => {
                    const picker = input._flatpickr || (input.nextElementSibling && input.nextElementSibling._flatpickr);

                    if (picker) {
                        if (picker.selectedDates.length > 0 || input.value) {
                            hasValue = true;
                            picker.clear(false);
                            picker.close();

                            if (picker.altInput) picker.altInput.blur();
                            if (picker.input) picker.input.blur();
                        }
                    } else if (input.value) {
                        hasValue = true;
                        input.value = '';
                    }
                });

                if (hasValue) {
                    inputs[0].dispatchEvent(new Event('input', {bubbles: true}));
                }
            });

            const callback = this.actionBar.dataset.callback;

            this[callback]();
        }
    }

    snapshotOfInitializeState() {
        this.actionBar.querySelectorAll('input').forEach(i => {
            if (i.hasAttribute('name') && !i.closest('.action__item--period-picker')) {
                this.initState[i.getAttribute('name')] = i.dataset.defaultValue.trim().length ? i.dataset.defaultValue.trim() : null;
            }
        });
    }

    checkState() {
        const currentState = {};

        this.actionBar.querySelectorAll('input').forEach(i => {
            if (i.hasAttribute('name') && !i.closest('.action__item--period-picker')) {
                currentState[i.getAttribute('name')] = i.value.trim().length ? i.value.trim() : null;
            }
        });

        const isSameAsInitializeState = JSON.stringify(this.initState) === JSON.stringify(currentState);

        if (isSameAsInitializeState) {
            this.actionBar.querySelector('.action__item--clear-filters button').classList.add('button--disabled');
        } else {
            this.actionBar.querySelector('.action__item--clear-filters button').classList.remove('button--disabled');
        }
    }

    restoreInitializeState() {
        this.actionBar.querySelectorAll('input').forEach(i => {

            if (i.closest('.action__item--period-picker')) {
                return;
            }

            if (i.closest('.action__item--date-range')) {
                const picker = i._flatpickr || (i.nextElementSibling && i.nextElementSibling._flatpickr);

                if (picker) {
                    if (picker.selectedDates.length > 0 || i.value) {
                        picker.clear(false);
                        picker.close();

                        if (picker.altInput) picker.altInput.blur();
                        if (picker.input) picker.input.blur();
                    }
                } else if (i.value) {
                    i.value = '';
                }
            } else {
                i.value = this.initState[i.getAttribute('name')];

                const dd = i.closest('.dropdown');

                if (dd) {
                    dd.querySelector('.dropdown__selected span').textContent = dd.querySelector('.dropdown__item[data-value="' + i.value + '"]').textContent;
                    dd.querySelector('.dropdown__selected').dataset.value = dd.querySelector('.dropdown__item[data-value="' + i.value + '"]').dataset.value;
                }

                const segment = i.closest('.segments');

                if (segment) {
                    segment.querySelector('span.active').classList.remove('active');
                    segment.querySelector('span[data-value="' + i.value + '"]').classList.add('active');
                }
            }
        });

        this.actionBar.querySelector('input:not([name="search"]):not([name="current-period"])').dispatchEvent(new Event('input', {bubbles: true}));
    }

    resetScrollPosition() {
        const main = document.querySelector('main');

        if (main.scrollTop > 0) {
            requestAnimationFrame(() => {
                main.scrollTo({
                    top: 150,
                    behavior: 'instant'
                });

                requestAnimationFrame(() => {
                    main.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                });
            });
        }
    }

    segments() {
        this.actionBar.querySelectorAll('.segments').forEach(segment => {
            segment.addEventListener('click', e => {
                const value = e.target.dataset.value;
                const input = segment.querySelector('input');

                if (typeof value !== 'undefined' && input && input.value !== value) {
                    segment.querySelectorAll('span').forEach(seg => seg.classList.remove('active'));
                    e.target.classList.add('active');

                    input.value = value;
                    input.dispatchEvent(new Event('input', {bubbles: true}));
                }
            });
        });
    }

    fetchParams() {
        const params = {};

        this.actionBar.querySelectorAll('input').forEach(input => {
            const inputName = input.getAttribute('name');

            if (inputName && !input.closest('.action__item--period-picker')) {
                params[inputName] = (input.value.trim().length ? input.value.trim() : null);
            }
        });

        return params;
    }

    transactions() {
        const params = {
            offset: 0,
            limit: 50
        };

        let lastInputChangeValue;

        const triggerCallback = () => {
            Object.assign(params, this.fetchParams());

            lastInputChangeValue = (params.search ? params.search.trim() : null);

            gridLoading();
            data.transactions(params).then(results => {
                if (results.status === 'success' && !results.error) {
                    document.querySelector('.grid__content').innerHTML = '';
                    const items = Object.keys(results.data).length;

                    Object.entries(params).forEach(([key, value]) => {
                        button.dataset[key] = value;
                    });

                    button.dataset.offset = params.offset + items;

                    if (items < params.limit) {
                        button.classList.add('button--disabled');
                    } else {
                        button.classList.remove('button--disabled');
                    }

                    const grid = document.querySelector('.grid__content');
                    const template = document.getElementById('transactions-list-template').content;
                    const row = template.querySelector('.grid__row');

                    if (items) {
                        const render = new Renders();

                        for (let txId in results.data) {
                            grid.appendChild(render.transaction(results.data[txId], row.cloneNode(true)));
                        }
                    } else {
                        const noResultsRow = row.cloneNode(true);
                        noResultsRow.classList.add('grid__row--no-results');
                        noResultsRow.innerHTML = __('text_no_matches_found');
                        grid.appendChild(noResultsRow);
                    }
                }

                gridLoading(false);
            });
        };

        const button = document.querySelector('.button--load-more');
        const data = new Data();

        let debounceTimer;
        const handlerInputChange = (currentValue) => {
            clearTimeout(debounceTimer);

            debounceTimer = setTimeout(() => {
                if (currentValue !== lastInputChangeValue) {
                    triggerCallback();
                }
            }, 400);
        };

        this.actionBar.addEventListener('input', e => {
            this.checkState();

            const isSearch = e.target.getAttribute('name') === 'search';

            if (isSearch) {
                const currentValue = e.target.value.trim();
                handlerInputChange(currentValue);
            } else {
                triggerCallback();
            }

            requestAnimationFrame(() => {
                this.resetScrollPosition();
            });
        });
    }

    templates() {
        const params = {
            offset: 0,
            limit: 50
        };

        let lastInputChangeValue;

        const triggerCallback = () => {
            Object.assign(params, this.fetchParams());
            lastInputChangeValue = (params.search ? params.search.trim() : null);

            gridLoading();
            data.transactionTemplates(params).then(results => {
                if (results.status === 'success' && !results.error) {
                    document.querySelector('.grid__content').innerHTML = '';
                    const items = Object.keys(results.data).length;

                    Object.entries(params).forEach(([key, value]) => {
                        button.dataset[key] = value;
                    });

                    button.dataset.offset = params.offset + items;

                    if (items < params.limit) {
                        button.classList.add('button--disabled');
                    } else {
                        button.classList.remove('button--disabled');
                    }

                    const grid = document.querySelector('.grid__content');
                    const template = document.getElementById('tx-tmp-list-template').content;
                    const row = template.querySelector('.grid__row');

                    if (items) {
                        const render = new Renders();

                        for (let txId in results.data) {
                            grid.appendChild(render.transactionTemplate(results.data[txId], row.cloneNode(true)));
                        }
                    } else {
                        const noResultsRow = row.cloneNode(true);
                        noResultsRow.classList.add('grid__row--no-results');
                        noResultsRow.innerHTML = __('text_no_matches_found');
                        grid.appendChild(noResultsRow);
                    }
                }

                gridLoading(false);
            });
        };

        const button = document.querySelector('.button--load-more');
        const data = new Data();

        let debounceTimer;
        const handlerInputChange = (currentValue) => {
            clearTimeout(debounceTimer);

            debounceTimer = setTimeout(() => {
                if (currentValue !== lastInputChangeValue) {
                    triggerCallback();
                }
            }, 400);
        };

        this.actionBar.addEventListener('input', e => {
            this.checkState();

            const isSearch = e.target.getAttribute('name') === 'search';

            if (isSearch) {
                const currentValue = e.target.value.trim();
                handlerInputChange(currentValue);
            } else {
                triggerCallback();
            }

            requestAnimationFrame(() => {
                this.resetScrollPosition();
            });
        });
    }

    calendar() {
        const calendarItems = document.querySelectorAll('.calendar__item');

        this.actionBar.addEventListener('input', e => {
            if (e.target.closest('.action__item--period-picker')) {
                return;
            }

            this.checkState();

            const searchInput = document.querySelector('.action__bar .action__item--search input');
            const searchValue = searchInput ? searchInput.value.trim().toLowerCase() : '';
            const params = this.fetchParams();

            localStorage.setItem('calendar_filters', JSON.stringify(params));

            if (JSON.stringify(this.initState) !== JSON.stringify(params)) {
                document.querySelectorAll('.calendar .totals').forEach(item => item.classList.add('hide-element'));
            } else {
                document.querySelectorAll('.calendar .totals').forEach(item => item.classList.remove('hide-element'));
            }

            calendarItems.forEach(item => {
                let matchesSearch = true;
                if (searchValue) {
                    let texts = item.dataset.comment || '';
                    texts += ' ' + item.querySelector('.item-header').textContent;
                    item.querySelectorAll('.item-group').forEach((i) => {
                        texts += ' ' + i.textContent;
                    });

                    texts = texts.replace(/\s+/g, ' ').trim().toLowerCase();

                    matchesSearch = texts.includes(searchValue);
                }

                let matchesType = true;
                if (params.type !== 'all') {
                    if (params.type !== 'scheduled') {
                        matchesType = item.dataset.type === params.type;
                    } else {
                        matchesType = parseInt(item.dataset.scheduled) === 1;
                    }
                }

                const isVisible = matchesSearch && matchesType;

                item.classList.toggle('hide-element', !isVisible);
            });

            requestAnimationFrame(() => {
                this.resetScrollPosition();
            });
        });
    }
}